module.exports = __webpack_public_path__ + "static/img/aboutus_img2.10bc1f56.png";